import { Box, styled } from '@mui/material';

const StyledLargeSessionCardContainer = styled(Box)(() => ({
  alignItems: 'stretch',
  display: 'flex'
}));

export default StyledLargeSessionCardContainer;
